var _path, _rect, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElementsVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5502 4.56013C7.37558 4.02918 6.6245 4.02918 6.44988 4.56013L6.18307 5.37142C5.95322 6.0703 5.40506 6.61846 4.70618 6.84831L3.89489 7.11513C3.36394 7.28975 3.36394 8.04083 3.89488 8.21545L4.70618 8.48226C5.40506 8.71211 5.95322 9.26027 6.18306 9.95915L6.44988 10.7704C6.6245 11.3014 7.37558 11.3014 7.5502 10.7704L7.81702 9.95915C8.04687 9.26027 8.59503 8.71211 9.29391 8.48226L10.1052 8.21545C10.6361 8.04083 10.6362 7.28975 10.1052 7.11513L9.29391 6.84831C8.59503 6.61846 8.04687 6.0703 7.81702 5.37142L7.5502 4.56013Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14.6653,
    width: 6,
    height: 6,
    rx: 1.5,
    stroke: "black",
    strokeWidth: 1.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8906,
    y: 4.55591,
    width: 6.21875,
    height: 6.21875,
    rx: 3,
    stroke: "black",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7891 18.1877V17.1429C14.7891 15.7755 14.7891 15.0919 15.0677 14.7479C15.3098 14.4488 15.6762 14.278 16.0609 14.2847C16.5035 14.2924 17.0272 14.7319 18.0747 15.6108L18.6972 16.1332C19.3247 16.6597 19.6385 16.923 19.7531 17.2378C19.8536 17.5139 19.8536 17.8167 19.7531 18.0928C19.6385 18.4075 19.3247 18.6708 18.6972 19.1974L18.0747 19.7198L18.0747 19.7198C17.0272 20.5987 16.5035 21.0381 16.0609 21.0459C15.6762 21.0526 15.3098 20.8817 15.0677 20.5827C14.7891 20.2387 14.7891 19.555 14.7891 18.1877Z",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementsVector);
export default __webpack_public_path__ + "static/media/ElementsVector.eee72c26f8c896b4370ed091097c5914.svg";
export { ForwardRef as ReactComponent };